import type { HTMLAttributes, ReactNode } from 'react';

export function Card({ pad, className, children, ...rest }: HTMLAttributes<HTMLElement> & { pad?: boolean }) {
  return (
    <section className={['ui-card', pad && 'ui-card--pad', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </section>
  );
}

export function CardHeader({ title, subtitle, actions, id }: { title: ReactNode; subtitle?: ReactNode; actions?: ReactNode; id?: string }) {
  return (
    <header className="ui-card__header">
      <div style={{ minWidth: 0 }}>
        <h2 className="ui-card__title" id={id}>
          {title}
        </h2>
        {subtitle && <p className="ui-card__subtitle">{subtitle}</p>}
      </div>
      {actions && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>{actions}</div>}
    </header>
  );
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={['ui-card__body', className].filter(Boolean).join(' ')}>{children}</div>;
}

export function CardFooter({ children }: { children: ReactNode }) {
  return <footer className="ui-card__footer">{children}</footer>;
}
